import {Component, ViewEncapsulation} from '@angular/core';
import {WidgetComponent} from '../widget.component';
import {OrganizationService} from '../../../_service/organization.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {HttpService} from '../../../_service/http.service';
import {Metrika} from 'ng-yandex-metrika';
import {PaySaldoService} from "../pay-saldo.service";
@Component({
  selector: 'app-widget',
  // host: {
  //   '(document:click)': 'handleClick($event)',
  // },
  templateUrl: 'academ-widget.component.html',
  styleUrls: ['../../styles.css', 'color-scheme.css', '../../ng2-select.css'],
  encapsulation: ViewEncapsulation.None
})
export class AcademWidgetComponent extends WidgetComponent {

  constructor(organizationService: OrganizationService,
              route: ActivatedRoute,
              titleService: Title,
              paySaldoService: PaySaldoService,
              router: Router,
              metrika: Metrika,
              httpService: HttpService) {
    super(organizationService, route, titleService, paySaldoService, router, metrika, httpService);
    titleService.setTitle('Лёгкий Платёж Академический');
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/academ-widget/academ-widget.component.ts